import {ReviewSection3} from "../review/ReviewSection3";
import React, {useEffect, useRef, useState} from "react";
import style from "../review/review.module.scss";
import {useReviewsGetter} from "../review/hooks/useReviewsGetter";
import {useLocationHistory} from "../../../hooks/location/useLocationHistory";
import {useReviewFunctions} from "../review/hooks/useReviewFunctions";
import {ReviewDisplayPosition} from "../../../types/review";

export function PurchaseReviewField() {
    const reviewListRef = useRef<HTMLElement>(null);
    const { getReviews } = useReviewsGetter();
    const [pageNum, setPageNum] = useState<number | null>(null);
    const { getPageNumFromUrl, getPage } = useReviewFunctions();
    const size = 5;

    useLocationHistory({
        callbackOnBack: () => getPage({pageNum, setPageNum, reviewListRef}),
        callbackOnNext: () => getPage({pageNum, setPageNum, reviewListRef}),
    });

    useEffect(() => {
        if (pageNum !== null) {
            getReviews({
                page: pageNum,
                size: size,
            }).then();
        }
        // eslint-disable-next-line
    }, [pageNum]);

    useEffect(() => {
        setPageNum(getPageNumFromUrl());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getPageNumFromUrl]);

    return(
        <main className={style.main}>
            <ReviewSection3 reviewListRef={reviewListRef} displayPosition={ReviewDisplayPosition.PRODUCT}/>
        </main>
    )
}